import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { AccountsandFinanceurl } from "../../../../config";
import { accountSubcategoryFields } from "../../../../data/DynamicTable/AccountsDynamicForms";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";
import { allAccountCategories } from "../../../../data/Axios/queries";

const base_url = AccountsandFinanceurl.uri;

const AccountSubCategoryForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = parseInt(decodedToken.CompanyId);

  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);

  const initialValues = {
    accountCategory: props.data ? props.data.accountCategory : "",
    accountCategoryId: props.data ? props.data.accountCategoryId : "",
    accountName: props.data ? props.data.accountName : "",
    accountNumber: props.data ? props.data.accountNumber : "",
    accountType: props.data ? props.data.accountType : "",
    currency: props.data ? props.data.currency : "",
    rate: props.data ? props.data.rate : "",
    parentAccount: props.data ? props.data.parentAccount : "",
    companyId: companyId,
    id: props.data ? props.data.id : 0,
  };

  useEffect(() => {
    async function fetchCategories() {
      try {
        const data = await graphqlQuery(allAccountCategories, base_url);
        if (data && Array.isArray(data)) {
          setCategoryData(data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchCategories();
  }, []);

  const categoryOptions = categoryData.map((cat) => ({
    value: cat.id,
    label: cat.categoryName,
  }));

  const getCategoryName = (id) => {
    const cat = categoryData.find((c) => c.id === id);
    return cat ? cat.categoryName : "";
  };

  // THIS IS THE FIX: We intercept values right before submission
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      // CRITICAL: Force accountCategory to be the correct name based on selected ID
      const selectedCategoryName = getCategoryName(values.accountCategoryId);

      const mutationData = props.isEditing
        ? {
            id: values.id,
            accountCategoryId: parseInt(values.accountCategoryId),
            accountCategory: selectedCategoryName, // This is now guaranteed correct
            accountName: values.accountName,
            accountNumber: values.accountNumber,
            accountType: values.accountType,
            currency: values.currency,
            rate: parseFloat(values.rate || 0),
            parentAccount: 0,
            status: "Active",
            companyId,
          }
        : {
            accountCategoryId: parseInt(values.accountCategoryId),
            accountCategory: selectedCategoryName, // Always correct
            accountName: values.accountName,
            accountNumber: values.accountNumber,
            accountType: values.accountType,
            currency: values.currency,
            rate: parseFloat(values.rate || 0),
            parentAccount: 0,
            status: "Active",
            companyId,
          };


      const result = await generateAndExecuteMutation(
        props.isEditing ? "updateAccountSubCategory" : "createAccountSubCategory",
        mutationData,
        "accountsubcategory",
        base_url
      );

      if (result && Object.values(result)[0] !== null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Account sub-category ${props.isEditing ? "updated" : "created"} successfully!`,
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to save sub-category.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  // Pre-fill when editing
  const handleFormLoad = (setFieldValue) => {
    if (props.data?.accountCategoryId) {
      const name = getCategoryName(props.data.accountCategoryId);
      setFieldValue("accountCategory", name);
    }
  };

  // Normal fields — NO onChange needed anymore
  const fields = [
    ...accountSubcategoryFields,
    {
      name: "accountCategoryId",
      label: "Account Category",
      type: "select",
      options: categoryOptions,
      gridColumn: "span 2",
      required: true,
      // Removed onChange — we handle it in handleSubmit instead
    },
  ];

  if (loading) return <CircularProgress />;

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      onFormLoad={handleFormLoad}
      title={props.isEditing ? "Edit Account Sub-Category" : "Create Account Sub-Category"}
      subtitle="Add or update account sub-category"
    />
  );
};

export default AccountSubCategoryForm;